import { Reducer } from 'redux';
import { KnownAction } from './orderActions';
import { ApiOrderState } from './orderModels';

/* tslint:disable */
// ----------------
// REDUCER - For a given state and action, returns the new state.
// To support time travel, this must not mutate the old state.
export const reducer: Reducer<ApiOrderState> = (state: ApiOrderState, action: KnownAction) => {
    if (state === null || state === undefined) {
        state = {
            orders: [],
            order: undefined,
            loading: false
        };
    }

    switch (action.type) {
        case 'SET_ORDERS':
            return Object.assign({}, state, { orders: action.data });
        case 'SET_SINGLE_ORDER':
            return Object.assign({}, state, { order: action.data });
        case 'SET_LOADING_ORDERS':
            return Object.assign({}, state, { loading: action.data });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/data/order/orderReducers.ts